export interface AccApplicationInterview {
	accApplicationInterviewId: number,
	valuePropositionRating: number,
	sustainabilityRating: number,
	coachabilityRating: number,
	timeCommitmentRating: number,
	notes: string,
	updatedByStaffId: number,
	updatedByStaffName: string,
	updatedUTC: number,
}

export interface AccApplicationInterviewWithAccApplicationId extends AccApplicationInterview {
	accApplicationId: number,
}

export const ACC_APPLICATION_INTERVIEW_RATING_VALUE_MAP: { [index: number]: number } = {
	1: 0,
	2: 15,
	3: 20,
	4: 25,
};
